import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Icons } from '@core/models/icons/icon.model';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  registerIcons(): void {
    this.load(Icons, 'icons');
  }

  private load(icons: typeof Icons, url: string): void {
    Object.keys(icons).forEach((icon) => {
      this.iconRegistry.addSvgIcon(
        icon,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `${url}/${icons[icon]}.svg`,
        ),
      );
    });
  }
}
